import { ArrowMediumDown32, Cancel32, Checkmark32 } from '@packages/themes/icons';
import { Box, Button } from '@packages/shared';
import type { FC, ReactNode } from 'react';

/** Styles for the checkmark icon. !important is needed because otherwise svg icon style on button will override this */
const checkmarkIconStyle = { height: '1.5rem !important', width: '1.5rem !important' };

export type FilterSettingsDesktopButtonProps = {
  /** Filter that should be rendered within the popover */
  children: ReactNode;
  isActive?: boolean;
  isPopoverOpen?: boolean;
  onClick?: (anchor: HTMLButtonElement) => void;
};

export const FilterSettingsDesktopButton: FC<FilterSettingsDesktopButtonProps> = ({
  children,
  isActive,
  isPopoverOpen,
  onClick,
}) => {
  const icon = isActive ? <Checkmark32 sx={checkmarkIconStyle} /> : <ArrowMediumDown32 />;

  return (
    <Button
      fullWidth
      sx={{
        display: 'flex',
        height: '1.25rem',
        paddingRight: 1,
        '& svg': {
          width: '2rem',
          height: '2rem',
        },
      }}
      onClick={(event) => {
        if (event.currentTarget instanceof HTMLButtonElement) {
          onClick?.(event.currentTarget);
          event.stopPropagation();
        }
      }}
    >
      <Box
        sx={{
          width: '100%',
          marginRight: 'auto',
          overflow: 'hidden',
          textAlign: 'left',
        }}
      >
        {children}
      </Box>
      {isPopoverOpen ? <Cancel32 /> : icon}
    </Button>
  );
};
